import styled from "styled-components";

export const Label = styled.label`
    font-weight: 600;
    font-size: 0.9375rem;
    margin-bottom: 0.9375rem;
    color: ${props => props.theme.palette.common.black};
`;

interface IInput {
    error?: string | boolean;
}

export const Input = styled.input<IInput>`
    background: transparent;
    border: 1px solid #ded5d5;
    transition: border 0.3s ease;
    padding: 1.1875rem 0 1.1875rem 0.9375rem;
    font-size: 1rem;
    color: ${props => props.theme.palette.common.black};
    &::placeholder {
        opacity: 0.5;
        transition: 0.3s ease;
    }
    &:hover,
    &:focus {
        border: 1px solid ${props => props.theme.palette.primary.main};
        &::placeholder {
            padding-left: 20px;
            opacity: 0;
        }
    }
    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
    ${props =>
        props.error &&
        `
        border-color: ${props.theme.palette.error.main};
    `}
`;

export const InputGroupContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    textarea {
        max-width: 100%;
        min-height: 200px;
    }
`;

export const Validation = styled.small`
    margin-top: 5px;
    font-weight: 500;
    color: ${props => props.theme.palette.error.main};
`;
